import * as React from "react";
import styled from "styled-components";

import { colors } from "../../common/utils/style";
import Icon from "../../common/components/Icon";
import Translate from "../../common/components/Translate";
import Spinner from "../../common/components/atoms/Spinner";
import PostSelectBoxItem, { PostSelectBoxItemModels } from "./PostSelectBoxItem";

type Post = PostSelectBoxItemModels["Post"];

export interface PostSelectBoxListModels {
  Post: Post;
}

interface Props {
  options: Post[];
  value: Post | null;
  newPostLink?: string;
  isFiltered: boolean;
  isLoading: boolean;
  onChange: (post: Post | null) => void;
}

class PostSelectBoxList extends React.PureComponent<Props> {
  public items: PostSelectBoxItem[];

  constructor(props: Props) {
    super(props);
    this.items = [];
  }

  public render() {
    const { options, value, newPostLink, isFiltered, isLoading, onChange } = this.props;
    return (
      <List>
        <CurrentValue>
          <CurrentValueHeader>
            <Translate id="company_feed.pin.current" />
          </CurrentValueHeader>
          {value ? (
            <CurrentValueItem post={value} isSelected />
          ) : (
            <DefaultOption current>
              <DefaultOptionThumbnail />
              <Translate id="company_feed.pin.show_latest" />
            </DefaultOption>
          )}
        </CurrentValue>
        {!isFiltered && (
          <>
            {newPostLink && (
              <NewPost>
                <NewPostLink href={newPostLink}>
                  <NewPostIcon name="wt-icon-plus" />
                  <Translate id="company_feed.pin.new_post" />
                </NewPostLink>
              </NewPost>
            )}
            <DefaultOption onClick={() => onChange(null)}>
              <DefaultOptionThumbnail />
              <Translate id="company_feed.pin.show_latest" />
            </DefaultOption>
          </>
        )}
        {options.map((post, i) => (
          <PostSelectBoxItem
            key={post.id}
            ref={r => (this.items[i] = r!)}
            post={post}
            isSelected={!!value && value.id === post.id}
            onClick={onChange}
          />
        ))}
        {isLoading && <Spinner />}
      </List>
    );
  }
}

const List = styled.div`
  height: 435px;
  overflow-y: auto;
`;

const CurrentValue = styled.div`
  padding-top: 15px;
  border-bottom: solid 1px ${colors.lightgray1};
`;

const CurrentValueHeader = styled.div`
  padding: 0 20px;
  line-height: 1;
  font-size: 11px;
  color: ${colors.gray1};
`;

const CurrentValueItem = styled(PostSelectBoxItem)`
  cursor: auto;
  &:focus,
  &:hover {
    outline: none;
    background-color: inherit;
  }
`;

interface DefaultOptionStyleProps {
  current?: boolean;
}

const DefaultOption = styled.div`
  margin: 4px 12px;
  height: 44px;
  padding: 8px;
  font-size: 12px;
  font-weight: 600;
  color: ${(props: DefaultOptionStyleProps) => (props.current ? colors.gray3 : colors.gray1)};
  display: flex;
  align-items: center;
  cursor: ${(props: DefaultOptionStyleProps) => (props.current ? "auto" : "pointer")};
  &:focus,
  &:hover {
    outline: none;
    background: ${(props: DefaultOptionStyleProps) => (props.current ? "inherit" : colors.lightergray2)};
  }
`;

const DefaultOptionThumbnail = styled.div`
  display: inline-block;
  width: 44px;
  height: 44px;
  border-radius: 2px;
  margin-right: 11px;
  background: ${colors.lightergray2};
`;

const NewPost = styled.div`
  margin-top: 10px;
  padding: 0 12px;
`;

const NewPostLink = styled.a`
  height: 44px;
  padding: 8px;
  display: block;
  line-height: 44px;
  font-size: 12px;
  font-weight: 600;
  color: ${colors.gray1};
  &:hover {
    text-decoration: none;
    background: ${colors.lightergray2};
  }
`;

const NewPostIcon = styled(Icon)`
  display: inline-block;
  width: 44px;
  height: 44px;
  border-radius: 2px;
  font-size: 18px;
  margin-right: 11px;
  vertical-align: -1px;
  line-height: 41px;
  background: ${colors.lightergray2};
  text-align: center;
`;

export default PostSelectBoxList;



// WEBPACK FOOTER //
// ./frontend/src/posts/components/PostSelectBoxList.tsx